import moment from 'moment';
import { connect } from 'react-redux';
import { Form, message, DatePicker ,Button} from 'antd';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import InputComponent from '../../../Widgets/InputComponent';
import translation from '../../../../../commons/translation';

import {
  // getDeviceList,
  // getOrganisationsList,
  // getSitesList,
  submitJobPlan,
  // getJobPlanById
} from '../../../Utils/FormCalls';

const CommunicationLog = (props) => {
  // const [deviceList, setDeviceList] = useState([]);
  // const [organisationsList, setOrganisationsList] = useState([]);
  // const [sitesList, setSitesList] = useState([]);
  // const [recordData, setRecordData] = useState(props.formObject?.TaskData || []);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  const taskRef = useRef();
  const schedulingWorkOrderRef = useRef();

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       // const deviceResponse = await getDeviceList();
  //       // setDeviceList(deviceResponse.data);
  //       const organisationsResponse = await getOrganisationsList();
  //       setOrganisationsList(organisationsResponse.data);
  //       const sitesResponse = await getSitesList();
  //       setSitesList(sitesResponse.data);
  //     } catch (error) {
  //       message.warning(`${error.message}`);
  //     }
  //   };

  //   fetchData();
  // }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      schedulingWorkOrderRef.current.setFieldsValue(props.formObject);
      taskRef.current.setFieldsValue(props.formObject.TaskData);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
      // setRecordData(props.formObject?.TaskData || []);
    }
  }, [props, formObject, translationCache]);

  const handleChange = (value, key) => {
    const updatedFormObject = {
      ...formObject,
      [key]: value
    };
    schedulingWorkOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const onFinish = async (values) => {
    const payload = {
      ...formObject,
      ...values
    };
    const statusResponse = await submitJobPlan(payload);

    if (statusResponse?.message) {
      message.success(statusResponse.message);
      onReset();
    } else if (statusResponse?.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    taskRef.current.resetFields();
    schedulingWorkOrderRef.current.resetFields();
  };

  // const jobPlanOnChange = async (value) => {
  //   const formObject = await getJobPlanById(value);
  //   const recordData = formObject.TaskData;
  //   setRecordData(recordData);
  //   setFormObject(formObject);
  // };

  return (
    <>
      <Form
        onFinish={onFinish}
        name={'CommunicationLog'}
        ref={schedulingWorkOrderRef}
        className="jobplan"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation(translationCache, constant.iD)}
            name="ID"
            onChange={(e) => handleChange(e.target.value, 'ID')}
            rules={[{ required: false, message: 'Please Input ID!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, constant.inputId)}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.creatdBy)}
            name="Created By"
            onChange={(value) => handleChange(value, 'Creatd By')}
            rules={[{ required: false, message: 'Please Input Creatd By!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, constant.inputId)}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.notificationTo)}
            name="NotificationTo"
            onChange={(e) => handleChange(e.target.value, 'NotificationTo')}
            rules={[{ required: false, message: 'Please Input NotificationTo!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, constant.inputNotificationTo)}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.triggeredDateTime)}
            name="TriggeredDateTime"
            onChange={(e) => handleChange(e.target.value, 'TriggeredDateTime')}
            rules={[{ required: false, message: 'Please Provide TriggeredDateTime' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              style={{ width: '70%' }}
              showTime={{
                defaultValue: moment('00:00:00', 'HH:mm:ss')
              }}
              placeholder={translation(translationCache, 'TriggeredDateTime')}
            />
          </Form.Item>
        </div>
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.save)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(CommunicationLog);